import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'react-bootstrap/lib/Modal';
import Collapse from 'react-bootstrap/lib/Collapse';
import classnames from 'classnames';
import moment from 'moment';
import i18n from 'i18next';

import {AGE_CONSENT_META_DATA_BIRTHDAY, AGE_CONSENT_TYPE, AGE_CONSENT_META_DATA_PARENTAL, AGE_CONSENT_FULL_AGE_LIMIT, SENSITIVE_DATA_CONSENT_TYPE, TOS_CONSENT_TYPE, PRIVACY_CONSENT_TYPE} from '../common'

import Checkbox from './Checkbox';
import Select from './Select';
import ConsentService from './ConsentService';

import './index.less';
import BlockContent     from '@sanity/block-content-to-react';

class ConsentModal extends React.Component {
    static displayName = 'Layout.Flow.ConsentModal';
    static propTypes = {
        t: PropTypes.func,
        applicationName: PropTypes.string
    };
    static defaultProps = {
        applicationName: null
    };

    constructor(props) {
        super(props);

        this.state = {
            isConseptsAccepted: null,
            userConsents: null,
            ageDay: null,
            ageMonth: null,
            ageYear: null,
            isParentalAcceptance: null,
        };
    }

    componentWillMount() {
        ConsentService.getUserConsents(this.props.applicationName, i18n.language).then(userConsents => {
            if (userConsents) {
                var ageConsent = userConsents.filter(consent => consent.type === AGE_CONSENT_TYPE);
                if (ageConsent.length > 0) {
                    var ageDay = null;
                    var ageMonth = null;
                    var ageYear = null;
                    var birthdayMetaData = ageConsent[0].metaData.filter(metaData => metaData.description === AGE_CONSENT_META_DATA_BIRTHDAY);
                    if (birthdayMetaData && birthdayMetaData.length > 0) {
                        var birthdayText = birthdayMetaData[0] ? birthdayMetaData[0].content || null : null;
                        if (birthdayText) {
                            var birthday = moment(birthdayText).startOf('day');
                            ageDay = birthday.date().toString();
                            ageMonth = birthday.month().toString();
                            ageYear = birthday.year().toString();
                            var age;
                            if (moment(ageConsent.serverDate).isValid()) {
                                age = moment(ageConsent.serverDate).startOf('day').diff(birthday, 'years');
                            } else {
                                age = moment().utc().startOf('day').diff(birthday, 'years');
                                console.log("Server didn't provide Date header, age calculation applies user time in utc");
                            }
                            if (age < AGE_CONSENT_FULL_AGE_LIMIT) {
                                ageConsent[0].isMissingGuardianCheck = true;
                            }
                        }
                    }
                    var isParentalAcceptance = false;
                }
                this.setState({
                    userConsents,
                    ageDay,
                    ageMonth,
                    ageYear,
                    isParentalAcceptance
                });
            } else {
                this.setState({
                    userConsents: null
                });
            }
        }).catch(e => console.error('Unexpected error occurred on getting user consents', e));
    }

    flipContentVisibility = (i) => {
        var userConsents = this.state.userConsents;
        var userConsent = Object.assign({}, this.state.userConsents[i], { isContentVisible: !this.state.userConsents[i].isContentVisible });
        userConsents[i] = userConsent;
        this.setState({ userConsents });
    }

    consentsAcceptClick = () => {
        var userConsents = this.state.userConsents;
        for (let i = 0; i < userConsents.length; i++) {
            let userConsent = userConsents[i];
            userConsent = Object.assign({}, userConsent, { isMissingCheck: false }, { isMissingAgeSelect: false }, { isMissingGuardianCheckIcon: false });
            userConsents[i] = userConsent;
        }
        this.setState({ userConsents }, () => {
            setTimeout(() => { // Hack to handle too fast optimized rendering without class being changed
                var isAnyConsentMissingCheck = false;
                for (let i = 0; i < userConsents.length; i++) {
                    let userConsent = userConsents[i];
                    if (userConsent.type === AGE_CONSENT_TYPE) {
                        if (this.state.ageDay && this.state.ageMonth && this.state.ageYear) {
                            var birthday = moment().set('date', this.state.ageDay).set('month', this.state.ageMonth).set('year', this.state.ageYear).startOf('day');
                            var age;
                            if (moment(userConsent.serverDate).isValid()) {
                                age = moment(userConsent.serverDate).startOf('day').diff(birthday, 'years');
                            } else {
                                age = moment().utc().startOf('day').diff(birthday, 'years');
                                console.log("Server didn't provide Date header, age calculation applies user time in utc");
                            }
                            if (age < AGE_CONSENT_FULL_AGE_LIMIT && !this.state.isParentalAcceptance) {
                                userConsent.isMissingGuardianCheckIcon = true;
                                isAnyConsentMissingCheck = true;
                            }
                            else {
                                var birthdayMetaData = userConsent.metaData.filter(metaData => metaData.description === AGE_CONSENT_META_DATA_BIRTHDAY)[0];
                                var parentalMetaData = userConsent.metaData.filter(metaData => metaData.description === AGE_CONSENT_META_DATA_PARENTAL)[0];
                                if (!birthdayMetaData) {
                                    birthdayMetaData = {content: '', description: AGE_CONSENT_META_DATA_BIRTHDAY};
                                }
                                if (!parentalMetaData) {
                                    parentalMetaData = {content: '', description: AGE_CONSENT_META_DATA_PARENTAL};
                                }
                                userConsent.accepted = true;
                                birthdayMetaData.content = moment().set('date', this.state.ageDay).set('month', this.state.ageMonth).set('year', this.state.ageYear).format('YYYY-MM-DD');
                                parentalMetaData.content = this.state.isParentalAcceptance.toString();
                                userConsent.metaData[0] =  birthdayMetaData;
                                userConsent.metaData[1] =  parentalMetaData;
                            }
                        } else {
                            userConsent.isMissingAgeSelect = true;
                            isAnyConsentMissingCheck = true;
                        }
                    }
                    else if (userConsent.required && !userConsent.accepted) {
                        userConsent = Object.assign({}, userConsent, { isMissingCheck: true });
                        isAnyConsentMissingCheck = true;
                    }
                    userConsents[i] = userConsent;
                }
                this.setState({ userConsents });
                if (!isAnyConsentMissingCheck) {
                    this.setState({ isConseptsAccepted: true });
                    ConsentService.postUserConsents(userConsents).then().catch((ex) => {
                        console.error('Unexpected error occurred on saving user consents', ex);
                    });
                } else {
                    this.setState({ isConseptsAccepted: false });
                }
            }, 1);
        });
    }

    checkboxClicked = (i, checkbox) => {
        var accepted = checkbox.state.checked;
        var userConsents = this.state.userConsents;
        if (userConsents[i].type === AGE_CONSENT_TYPE) {
            var isParentalAcceptance = accepted;
            if (accepted && userConsents[i].isMissingGuardianCheckIcon) {
                userConsents[i].isMissingGuardianCheckIcon = false;
            }
            this.setState({
                userConsents,
                isParentalAcceptance
            });
        } else {
            var isMissingCheck = (!userConsents[i].isMissingCheck || !accepted) ?
                userConsents[i].isMissingCheck : !(userConsents[i].isMissingCheck && accepted); // For hiding missing warning if checked
            var userConsent = Object.assign({}, this.state.userConsents[i], { accepted }, { isMissingCheck });
            userConsents[i] = userConsent;
            this.setState({ userConsents });
        }
    }

    ageValueChanged(ageDay, ageMonth, ageYear) {
        if (ageDay && ageMonth && ageYear) {
            var ageConsent = this.state.userConsents.filter(userConsent => userConsent.type === AGE_CONSENT_TYPE)[0];
            var birthday = moment().set('date', ageDay).set('month', ageMonth).set('year', ageYear).startOf('day');
            var age;
            if (moment(ageConsent.serverDate).isValid()) {
                age = moment(ageConsent.serverDate).startOf('day').diff(birthday, 'years');
            } else {
                age = moment().utc().startOf('day').diff(birthday, 'years');
                console.log("Server didn't provide Date header, age calculation applies user time in utc");
            }
            if (ageConsent.isMissingAgeSelect) {
                ageConsent.isMissingAgeSelect = false;
            }
            if (age < AGE_CONSENT_FULL_AGE_LIMIT) {
                ageConsent.isMissingGuardianCheck = true;
            } else {
                ageConsent.isMissingGuardianCheck = false;
                ageConsent.isMissingGuardianCheckIcon = false;
            }
        }
        var userConsents = this.state.userConsents;
        this.setState({
            userConsents,
            ageDay,
            ageMonth,
            ageYear
        })
    }

    listSensitiveConsents(sensitiveList) {
        const {t} = this.props;
        const sensitiveDataList = [];

        for (const sensitiveDataItem of sensitiveList) {
            const translationKey = sensitiveDataItem.dataTypeTranslationKey.replace('gdpr.', 'gdpr:')
            sensitiveDataList.push(<li id={sensitiveDataItem.dataTypeId} key={sensitiveDataItem.dataTypeId} className='sensitive-consent-list'>{`${t(translationKey)}`}</li>)
        }

        return <ul className='consent-modal-sensitive-data-list'>{sensitiveDataList}</ul>
    }

    getUserConsentsElements = () => {
        const { t } = this.props;
        const privacyBlockRenderer = (props) => {
            const {style = 'normal', markDefs= []} = props.node
            if (style === 'h2' && markDefs) {
                if (markDefs[0] && markDefs[0].html_id) {
                    return <h2 id={markDefs[0].html_id}> {props.children}</h2>
                }
            }
            return BlockContent.defaultSerializers.types.block(props)
        }
        const tosBlockRenderer = (props) => {
            const {style = 'normal', markDefs= []} = props.node
            if (style === 'normal' && markDefs){
                if (markDefs[0] && markDefs[0].href) {
                    markDefs[0].href = '#' + props.node.children[0].text;
                }
            }
            if (style === 'h2') {
                return <h2 id={props.node.children[0].text}> {props.children}</h2>
            }
            return BlockContent.defaultSerializers.types.block(props)
        }
        var userConsentsElems = [];
        for (var i = 0; i < this.state.userConsents.length; i++) {
            var userConsent = this.state.userConsents[i];
            var requiredTextClass = classnames({
                'consent-check-required-text': true,
                'visible': userConsent.isMissingCheck
            });
            var requiredIconClass = classnames({
                'consent-check-required-icon': true,
                'visible': userConsent.isMissingCheck
            });
            if (userConsent.type === AGE_CONSENT_TYPE) { // Age consent is a special case
                var yearOptions = [];
                var year = moment().year();
                while (year >= 1900) {
                    yearOptions.push(<option key={year} value={(year)}>{year--}</option>);
                }
                var monthOptions = [];
                monthOptions.push(<option key="0" value="0">{t(['date:month.JANUARY.short', '1'])}</option>);
                monthOptions.push(<option key="1" value="1">{t(['date:month.FEBRUARY.short', '2'])}</option>);
                monthOptions.push(<option key="2" value="2">{t(['date:month.MARCH.short', '3'])}</option>);
                monthOptions.push(<option key="3" value="3">{t(['date:month.APRIL.short', '4'])}</option>);
                monthOptions.push(<option key="4" value="4">{t(['date:month.MAY.short', '5'])}</option>);
                monthOptions.push(<option key="5" value="5">{t(['date:month.JUNE.short', '6'])}</option>);
                monthOptions.push(<option key="6" value="6">{t(['date:month.JULY.short', '7'])}</option>);
                monthOptions.push(<option key="7" value="7">{t(['date:month.AUGUST.short', '8'])}</option>);
                monthOptions.push(<option key="8" value="8">{t(['date:month.SEPTEMBER.short', '9'])}</option>);
                monthOptions.push(<option key="9" value="9">{t(['date:month.OCTOBER.short', '10'])}</option>);
                monthOptions.push(<option key="10" value="10">{t(['date:month.NOVEMBER.short', '11'])}</option>);
                monthOptions.push(<option key="11" value="11">{t(['date:month.DECEMBER.short', '12'])}</option>);
                var dayOptions = [];
                var month = this.state.ageMonth;
                var daysInMonth = 31;
                if (month) {
                    var year = this.state.ageYear;
                    if (year) {
                        daysInMonth = moment().set('month', month).set('year', year).daysInMonth();
                    } else {
                        daysInMonth = moment().set('month', month).daysInMonth();
                    }
                    if (this.state.ageDay && this.state.ageDay > daysInMonth) {
                        this.setState({ ageDay: null });
                    }
                }
                for (var dayNumber = 1; dayNumber <= daysInMonth; dayNumber++) {
                    dayOptions.push(<option key={dayNumber} value={dayNumber}>{dayNumber}</option>);
                }

                var requiredTextClass = classnames({ 'consent-check-required-text': true, 'visible': userConsent.isMissingGuardianCheckIcon });
                var guardianCheckClasses = classnames({ 'consent-description': true, 'hidden': !userConsent.isMissingGuardianCheck });
                var ageSelectIconClasses = classnames({ 'consent-check-required-icon': true, 'visible': userConsent.isMissingAgeSelect });
                var guardianCheckIconClasses = classnames({ 'consent-check-required-icon': true, 'visible': userConsent.isMissingGuardianCheckIcon });
                userConsentsElems.push(<div className="consent-container" key={i} id={"consentType_" + userConsent.type}>
                    <div className="consent-title-row">
                        <span>
                            {t(['gdpr:consents.popup.dob_needed', 'You have to enter your date of birth to continue using Polar Flow'])}
                        </span>
                        <span className={requiredTextClass}>
                            {t(['gdpr:consents.popup.box_unchecked', 'You need to check this box to continue'])}
                        </span>
                    </div>
                    <div className="consent-description">
                        <div className="consent-description-main-row">
                            <span className="">
                            {t(['date:birthday', 'Day of birth'])}
                            </span>
                            <Select placeholder={t(['date:day', 'Day'])} value={this.state.ageDay} onChange={(day) => this.ageValueChanged(day, this.state.ageMonth, this.state.ageYear)}>
                                {dayOptions}
                            </Select>
                            <Select placeholder={t(['reports:chart.month', 'Month'])} value={this.state.ageMonth} onChange={(month) => this.ageValueChanged(this.state.ageDay, month, this.state.ageYear)}>
                                {monthOptions}
                            </Select>
                            <Select placeholder={t(['date:year', 'Year'])} value={this.state.ageYear} onChange={(year) => this.ageValueChanged(this.state.ageDay, this.state.ageMonth, year)}>
                                {yearOptions}
                            </Select>
                            <span className="consent-select-age">
                                <span className={ageSelectIconClasses} />
                            </span>
                        </div>
                    </div>
                    <div className={guardianCheckClasses}>
                        <div className="consent-description-main-row">
                            <div>
                                {t(['gdpr:consents.popup.guardian_consent.title', 'Guardian\'s consent'])}
                            </div>
                            <span className="consent-short-description">
                                {t(['gdpr:consents.popup.guardian_consent.text', 'As guardian, I give Polar permission to collect and process personal data of the young person in question as described in the Polar Privacy Notice'])}
                            </span>
                            <span className="consent-check">
                                <span className={guardianCheckIconClasses} />
                                <Checkbox onChange={this.checkboxClicked.bind(this, i)} />
                            </span>
                        </div>
                    </div>
                </div>);
            }
            else if (userConsent.type !== SENSITIVE_DATA_CONSENT_TYPE && userConsent.contentUrl) { // Accordion block
                var accordionCaretClass = classnames({
                    'icon': true,
                    'icon-arrow-up': true,
                    'caret-rotated': userConsent.isContentVisible
                });
                userConsentsElems.push(<div className="consent-container" key={i} id={"consentType_" + userConsent.type}>
                    <div className="consent-title-row">
                        <span>
                            {t([userConsent.name, '' + userConsent.name])}
                            {userConsent.required && '*'}
                        </span>
                        <span className={requiredTextClass}>
                            {t(['gdpr:consents.popup.box_unchecked', 'You need to check this box to continue'])}
                        </span>
                    </div>
                    <div className="consent-description">
                        <div className="consent-description-main-row">
                            <span className={"consent-short-description"} onClick={this.flipContentVisibility.bind(this, i)}>
                                <a>{t([userConsent.description, '' + userConsent.description])}</a>
                                <i className={accordionCaretClass} />
                            </span>
                            <span className="consent-check">
                                <span className={requiredIconClass} />
                                <Checkbox onChange={this.checkboxClicked.bind(this, i)} />
                            </span>
                        </div>
                            <Collapse in={userConsent.isContentVisible}>
                                <div className="consent-accordion">
                                   { userConsent.type === TOS_CONSENT_TYPE && userConsent.content &&
                                    <div className="consent-text" >
                                        <BlockContent blocks={userConsent.content} serializers={{types: {block: tosBlockRenderer}}} />
                                    </div>
                                   }
                                   { userConsent.type === PRIVACY_CONSENT_TYPE && userConsent.content &&
                                    <div className="consent-text" >
                                        <BlockContent blocks={userConsent.content} serializers={{types: {block: privacyBlockRenderer}}} />
                                    </div>
                                   }
                                </div>
                            </Collapse>
                    </div>
                </div>);
            } else { // Simple block without accordion
                userConsentsElems.push(<div className="consent-container" key={i} id={"consentType_" + userConsent.type}>
                    <div className="consent-title-row">
                        <span>
                            {t([userConsent.name, '' + userConsent.name])}
                            {userConsent.required && '*'}
                        </span>
                        <span className={requiredTextClass}>
                            {t(['gdpr:consents.popup.box_unchecked', 'You need to check this box to continue'])}
                        </span>
                    </div>
                    <div className="consent-description">
                        <div className="consent-description-main-row">
                            <span className="consent-short-description">
                                {t([userConsent.description, '' + userConsent.description])}
                                {userConsent.type === SENSITIVE_DATA_CONSENT_TYPE ? (
                                    <span>
                                        <a href={userConsent.contentUrl} target="_blank"> {t('common:see_full_details')}</a>
                                        {this.listSensitiveConsents(userConsent.sensitiveConsentDataTypes)}
                                    </span>
                                ) : null}
                            </span>
                            <span className="consent-check">
                                <span className={requiredIconClass} />
                                <Checkbox onChange={this.checkboxClicked.bind(this, i)} />
                            </span>
                        </div>
                    </div>
                </div>);
            }
        }
        return userConsentsElems;
    }

    render() {
        const { t } = this.props;
        const modalTitle = t(['gdpr:settings.missing_consent.header', 'We need your consent']);

        if (this.state.isConseptsAccepted || !this.state.userConsents) {
            return null;
        }
        var userConsentsElems = this.getUserConsentsElements();

        var languageCode = i18n.language;
        var langParts = languageCode.split("-");
        if (langParts.length === 2) {
            var langPart = langParts[0].toLowerCase();
            var countryPart = langParts[1].toLowerCase();
            languageCode = countryPart+"-"+langPart;
        }
        return (
            <Modal show bsClass="consent-modal">
                <Modal.Header>
                    <Modal.Title className="consent-modal-title">
                        {modalTitle}
                    </Modal.Title>
                    <a id="consent-modal-info-link" target="_blank" rel="noopener noreferrer"  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMiAyMiI+PHRpdGxlPmluZm8taWNvbjwvdGl0bGU+PHBhdGggZD0iTTEwLjEyNSwxNi4yOVYxMS4ybC0xLjQzNS4wMzFWOS4zNTVoMy42M1YxNi4yOWgtMi4yWk0xMi40MTcsNi4yMDdhMS41LDEuNSwwLDEsMS0xLjUtMS41QTEuNSwxLjUsMCwwLDEsMTIuNDE3LDYuMjA3WiIgZmlsbD0iIzAwOWJlMCIvPjxwYXRoIGQ9Ik0xMSwxQTEwLDEwLDAsMSwwLDIxLDExLDEwLDEwLDAsMCwwLDExLDFabTAsMTguNUE4LjUsOC41LDAsMSwxLDE5LjUsMTEsOC41LDguNSwwLDAsMSwxMSwxOS41WiIgZmlsbD0iIzAwOWJlMCIvPjwvc3ZnPg==);" href={"https://www.polar.com/{{LANG}}/legal/faq".replace("{{LANG}}", languageCode)}></a>
                </Modal.Header>
                <Modal.Body>
                    <div className="consents-body">
                        <div className="consents-information">
                            {t(['gdpr:consents.popup.general_info', 'Polar Flow is all about your training and hard work – moreover, your data. That’s why we ask you to review our Privacy Notice and go through these settings about the privacy of your data and how you allow us to handle it.'])}
                            <div className='consents-information-second-info'>
                            {t(['gdpr:consents.popup.general_info2', 'As we collect and process your data at Polar, we are bound by data protection regulations. This is why we need your explicit consent to handle your data.'])}
                            <a href="https://www.polar.com/{LANG}/legal/faq" target="_blank"> {t(['common:learn_more', 'Learn more'])}</a>
                            </div>
                        </div>
                        {userConsentsElems}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <a id="no-thanks-logout" href="/logout">
                        {t(['gdpr:consents.popup.no_thanks_button', 'No thanks, sign out'])}
                    </a>
                    {(this.state.isConseptsAccepted === false) &&
                        <span className="consent-button-click-required">
                            {t(['gdpr:consents.popup.consent_needed', 'We still need your consent'])}
                        </span>
                    }
                    <button type="button" className="accept-button" onClick={this.consentsAcceptClick}>
                        {t(['common:accept', 'Accept'])}
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}
const wrapped = translate(['common', 'gdpr'], { wait: true })(ConsentModal);
export { ConsentModal, wrapped as default };



// WEBPACK FOOTER //
// ./src/ConsentsLoginModal/index.jsx